import {
  HIDE_USERS_LOADING,
  SET_USERS_LIST,
  SHOW_USERS_LOADING,
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  loading: false,
  error: null,
};

const UsersList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_USERS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_USERS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case HIDE_USERS_LOADING:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default UsersList;
